import { fansubFeatured, fansubGroups } from "@/mocks/comicData";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Fansub() {
  return (
    <section id="fansub" className="scroll-mt-16 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="官方合作 · 全站独家"
          title="独家汉化组专区"
          subtitle="与多家汉化组深度合作，独家首发精翻作品。译者注释详尽，更新准时，还有月影汉化组日更力作。"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <article className="relative col-span-1 overflow-hidden rounded-lg lg:col-span-2">
            <div className="relative h-72 w-full md:h-96">
              <img
                src={fansubFeatured.imageUrl}
                alt={`${fansubFeatured.group} 独家作品《星陨之都》封面`}
                title={`${fansubFeatured.group} 独家 · 星陨之都 · 动漫之家漫画网`}
                className="h-full w-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-background-950/50 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-8">
                <span className="mb-3 inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-translate-2 text-sm"></i>
                  独家日更
                </span>
                <h3 className="font-heading text-xl font-bold text-white md:text-3xl">
                  {fansubFeatured.title}
                </h3>
                <p className="mt-3 max-w-xl text-xs leading-relaxed text-background-100 md:text-sm">
                  {fansubFeatured.desc}
                </p>
                <div className="mt-5">
                  <a
                    href="#contact"
                    className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                  >
                    立即追更
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </article>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-1">
            {fansubGroups.map((g) => (
              <div
                key={g.id}
                className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-lg text-secondary-700">
                  <i className="ri-team-line"></i>
                </span>
                <div className="min-w-0">
                  <h4 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
                    {g.name}
                    <i className="ri-vip-crown-fill text-accent-500"></i>
                  </h4>
                  <p className="truncate text-xs text-foreground-500">{g.works}</p>
                  <p className="mt-0.5 text-[11px] text-foreground-400">
                    {g.members} · {g.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}